import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dispatchitem',
  templateUrl: './dispatchitem.component.html',
  styleUrls: ['./dispatchitem.component.css']
})
export class DispatchitemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
